import Box from '@mui/material/Box';
import { useTheme } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import ListItem from "@mui/material/ListItem";
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import { Star } from "@mui/icons-material";
import AddCircleIcon from '@mui/icons-material/AddCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import Alert from '@mui/material/Alert';
import React, { Fragment, useEffect, useState } from 'react';
import AppConstants from "../../../common/AppConstants";
import Helper from '../../../common/Helper';
import { coachProfileService } from "../../../services";
import UploadIcon from "../../../sharedComponents/customIcons/UploadIcon";
import BackButton from "../../../sharedComponents/saveButton/BackButton";
import SaveButton from "../../../sharedComponents/saveButton/SaveButton";
import CofirmationDialogBox from "../../ManageData/cofirmationDialogBox";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1
    },
    grid: {
        padding: theme.spacing(1),
        alignSelf: 'center',
        display: 'flex',
    },
    gridIcons: {
        display: 'flex',
        '& button': {
            [theme.breakpoints.down("xs")]: {
                padding: theme.spacing(.75),
            },
        },
    },
    error: {
        borderColor: theme.palette.error.dark,
    },
    btnDel: {
        color: theme.palette.secondary.main
    },
    uploadInner: {
        "&:hover": {
            //border: `1px dashed ${theme.palette.text.primary}`,
            cursor: "pointer",
        },
        display: "flex",
        flexDirection: "column",
        //border: `1px dashed ${theme.palette.text.disabled}`,
        width: "100%",
        borderRadius: "4px",
        backgroundColor: theme.palette.background.paper,
        backgroundColor: "#e5e5e5",
        //color: theme.palette.text.secondary,
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        padding: theme.spacing(1),
    },
    upload: {
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
        display: "flex",
        overflow: "hidden",
        position: "relative",
        borderRadius: "4px",
        // width: '150px',
        width: "90%",
        cursor: "pointer",
        //color: 'red !important'
    },
    input: {
        fontSize: "80px",
        position: "absolute",
        left: "-450px",
        top: 0,
        opacity: 0,
        cursor: "pointer",
    },
    imageMargin: {
        marginRight: theme.spacing(4),
    },
}));

const ProfileVideos = ((props) => {

    const [formDataCollection, setFormData] = useState([getEmptyItem()]);
    const [loading, setLoading] = useState(false);
    const [deleteVideos, setDeleteVideos] = useState([]);



    useEffect(() => {

        let dataURL = formDataFromProp();
        // Handle empty data case
        if ((!props.data || props.data.length === 0)) {
            dataURL?.push(getEmptyItem());
        }

        // Validate data if necessary
        if (props.isInValid) {
            dataURL = ValidateData(dataURL);
        }

        // Set form data based on video category and validation state
        setFormData(dataURL);

    }, [props.data.length, props.isInValid, props.videoCategory]);


    function getVideoCategory() {
        return props.videoCategory === AppConstants.VIDEO_TYPE.PROFILE_VIDEO ? null : props.videoCategory;
    };

    function getReviewStatus() {
        if (props.videoCategory === AppConstants.VIDEO_TYPE.GAME_VIDEO) {
            return 'Pending';
        } else {
            return null;
        }
    };


    const ValidateData = (dataURL) => {
        dataURL.forEach(lastData => {
            if (lastData.title.value.trim() === '' && lastData.videoURL.value.trim() === '') {
                lastData.title.hasError = false;
                lastData.videoURL.hasError = false;
            } else {
                lastData.title.hasError = (lastData.title.value.trim() === '') ? true : false;
                lastData.videoURL.hasError = (lastData.videoURL.value.trim() === '') ? true : false;
            }
        })

        return dataURL;
    }

    const formDataFromProp = () => {
        if (props?.data && props?.data.length > 0) {
            return props?.data?.map((item) => {
                const updatedData = {
                    id: item?.id,
                    title: { value: item?.title, validationMessage: '', hasError: null },
                    videoURL: { value: item?.videoURL, validationMessage: '', hasError: null },
                    reviewedReason: item?.reviewedReason,
                    reviewedStatus: item?.reviewedStatus || getReviewStatus(),
                    videoCategory: getVideoCategory(),
                    isPrimaryVideo: item?.isPrimaryVideo
                }
                return updatedData;
            })
        } else {
            return [];
        }
    }

    function getEmptyItem() {
        let randomId = Helper.GetRandomId();
        return {
            id: randomId,
            title: { value: '', validationMessage: '', hasError: null },
            videoURL: { value: '', validationMessage: '', hasError: null },
            videoCategory: getVideoCategory(),
            isPrimaryVideo: false
        }
    }

    const uploadFile = (e, hasError, file) => {
        setLoading(true);
        let form = new FormData();
        form.append("files", file);
        coachProfileService
            .uploadProfileAssets(form)
            .then((imageUrl) => {
                e.formData.videoURL.value = imageUrl;
                handleInputChange(e, hasError)
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            });


    };


    function handleInputChange(e, hasError, setPrimaryVideo) {
        //... If setPrimaryVideo is true. User click the set primary button. In that case set all other video as non primary video
        if (setPrimaryVideo) {
            formDataCollection.forEach(data => {
                if (data.id !== e.itemId) {
                    data.isPrimaryVideo = false;
                }
            });
        }
        let data = [...formDataCollection];
        let index = data.findIndex(x => x.id === e.itemId)
        data[index] = e.formData;
        setFormData(data);
        if (!hasError || hasError == undefined) {
            let pureObject = formDataCollection && formDataCollection.length > 0 && formDataCollection.map(
                function (item) {
                    return {
                        id: item.id,
                        title: item.title.value,
                        videoURL: item.videoURL && item.videoURL.value ? item.videoURL.value : "",
                        reviewedReason: item?.reviewedReason,
                        reviewedStatus: item?.reviewedStatus,
                        videoCategory: item?.videoCategory,
                        isPrimaryVideo: item?.isPrimaryVideo
                    }
                });
            props.onChange(pureObject);
        }
    }


    function addItem() {
        //... Add a new item to the formDataCollection array.
        let dataCollection = [...formDataCollection];
        if (props?.maxVideoUploadLimit && dataCollection.length > props?.maxVideoUploadLimit) {
            return;
        } else {
            let lastData = dataCollection[dataCollection.length - 1];
            if (lastData.title.value.trim() === '' || lastData.videoURL.value.trim() === '') {
                lastData.title.hasError = (lastData.title.value.trim() === '') ? true : false;
                lastData.videoURL.hasError = (lastData.videoURL.value.trim() === '') ? true : false;
                lastData.reviewedStatus = getReviewStatus();

                handleInputChange({ itemId: lastData.id, formData: lastData }, true);
            } else {
                lastData.title.hasError = false;
                lastData.videoURL.hasError = false;
                dataCollection.push(getEmptyItem());
                setFormData(dataCollection);
            }
        }
    }

    function removeItem(itemId) {
        //... Remove an item from formDataCollection array.
        let videos = deleteVideos;
        let DataCollection = [...formDataCollection];
        if (DataCollection.length >= 1 && (itemId.videoURL.value !== "" || itemId.title.value !== "")) {
            if (itemId.videoURL.value && itemId.videoURL.value != null && itemId.videoURL.value != "") {
                videos.push(itemId.videoURL.value);
            }

            setDeleteVideos(videos);
            let index = DataCollection.findIndex(x => x.title.value === itemId.title.value && x.videoURL.value === itemId.videoURL.value);

            //... Set first item as primary video if primary video item is deleted.
            if (DataCollection[index] && DataCollection[index]?.isPrimaryVideo) {
                DataCollection.splice(index, 1);
                if (DataCollection.length > 0) {
                    DataCollection[0].isPrimaryVideo = true; // Set the first item as primary video
                }
            } else {
                DataCollection.splice(index, 1);
            }

            setFormData(DataCollection);
            let pureObject = DataCollection.map(function (dc) {
                return {
                    id: dc.id,
                    title: dc.title.value,
                    videoURL: dc.videoURL.value,
                    reviewedReason: dc.reviewedReason,
                    reviewedStatus: dc.reviewedStatus,
                    videoCategory: dc.videoCategory,
                    isPrimaryVideo: dc?.isPrimaryVideo
                }
            });
            props.onChange(pureObject);
        }
        // this.notifyParentAboutDataChange();
    }

    return (
        <Grid container>
            {formDataCollection && formDataCollection.length > 0 && formDataCollection.map((item, index) => {
                return (<Item key={index}
                    addMediaItem={addItem}
                    itemRow={item}
                    onItemChange={handleInputChange}
                    uploadFile={uploadFile}
                    showAddOption={(index === formDataCollection.length - 1) && (props?.maxVideoUploadLimit ? formDataCollection.length <= props?.maxVideoUploadLimit : true)}
                    removeItem={removeItem}
                    onProfileVideoRemove={props.deleteProfileVideo}
                    formDataCollection={formDataCollection}
                />
                )
            })}

            <Grid size={{ xs: 12, md: 12 }}>
                <ListItem style={{ justifyContent: "flex-end" }}>
                    {props.showBackButton &&
                        <BackButton
                            onClick={props.handlePreveStepClick}
                        />
                    }
                    {props.showSaveButton &&
                        <SaveButton isLoading={props.isLoading} onClick={() => props.onSave()}></SaveButton>
                    }
                </ListItem>
            </Grid>
        </Grid>
    )
});

function Item(props) {

    const theme = useTheme();
    const classes = useStyles();
    const [isLoading, setIsLoading] = useState(false);
    const [showError, setShowError] = useState(false);
    const allowedFileType = "video/mp4,video/mov";
    const [image, setImage] = useState(null);

    const [videoToDelete, setVideoToDelete] = useState(null);
    const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);

    let videoImg =
        "data:image/png;base64,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";
    const maxFileSize = 50;

    useEffect(() => {
        if (props.itemRow && props.itemRow.videoURL) {
            setImage(props.itemRow.videoURL.value);
        }
    }, [props.itemRow])

    const handleOnChange = async (e) => {
        let files = e.target.files;

        if (files && files[0]) {

            const isValidate = await validateFile(files);

            if (isValidate === true) {

                setIsLoading(true);
                // props.onChange(files[0]);
                handleItemInputChange(files[0].name, "videoURL", files[0]);
                //props.onProfileVideoChange(files[0]);
                let reader = new FileReader();

                reader.onload = (rEvent) => {
                    setImage(rEvent.target.result);
                    setIsLoading(false);
                };
                reader.readAsDataURL(files[0]);
            }
        }
    };

    //..check the duration of selected video file
    const getVideoDuration = file => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const media = new Audio(reader.result);
                media.onloadedmetadata = () => resolve(media.duration);
            };
            reader.readAsDataURL(file);
            reader.onerror = error => reject(error);
        });
    };


    const validateFile = async (files) => {
        setShowError(null);
        const fsize = files[0].size;
        const filesizeInMB = Math.round(fsize / 1024 / 1024);

        // Check if the videoCategory.
        if (props.itemRow.videoCategory === AppConstants.VIDEO_TYPE.PROFILE_VIDEO) {
            // The size of the file.
            if (filesizeInMB > maxFileSize) {
                setShowError("Please select a file less than " + maxFileSize + "  MB");
                return false;
            }
        }

        // Check if the gameCategory.
        if (props.itemRow.videoCategory === AppConstants.VIDEO_TYPE.GAME_VIDEO) {

            // Get the video duration
            const videoDuration = await getVideoDuration(files[0]);

            if (videoDuration > 30) {
                setShowError("Please select a video less than 30 seconds in duration.");
                return false;
            }
        }

        var allowedFileTypes = allowedFileType.split(',');
        if (files[0].type.match(allowedFileTypes[0]) == null && files[0].type.match(allowedFileTypes[1]) == null) {
            setShowError("Please upload mp4 or mov format video");
            return false;
        }
        return true;
    };


    function handleAddClick() {
        props.addMediaItem();
    }

    function handleItemInputChange(value, name, file) {
        let formData = props.itemRow;
        formData[name].value = value;
        formData[name].hasError = false;

        //... Call Parent
        if (name == "videoURL") {
            props.uploadFile({ itemId: props.itemRow.id, formData: formData }, false, file);
        }
        else {
            props.onItemChange({ itemId: props.itemRow.id, formData: formData }, false, file);
        }
    }

    function showImage(id) {
        let img = null;
        let imgVal = allowedFileType === "image/*" ? image : videoImg;
        if (imgVal && imgVal !== null)
            img = (
                <div className={classes.imageMargin}>
                    <Avatar alt="photo" src={imgVal} className={classes.image} />
                </div>
            );
        return img;
    }

    const handleConfirmation = (flag => {
        setOpenConfirmationDialog(false);
        if (flag == 'Y') {
            props.removeItem(videoToDelete)
        }
        else {
            setVideoToDelete(null);
        }
    })


    function setPrimaryVideo(rowData, isPrimaryVideo) {
        //... Set primary video only in case if data list length is greater than one.
        //... If their is only one video. By default it will be set as primary video
        if (props.formDataCollection.length > 1) {
            rowData.isPrimaryVideo = !isPrimaryVideo;
            props.onItemChange({ itemId: props.itemRow.id, formData: rowData }, false, true);
        }
    }

    return (
        <Fragment>
            <Grid size={{ xs: 12, md: 4 }} className={classes.grid}>
                {image && image !== null ? (
                    showImage(props.itemRow.id)
                ) : (
                    <div className={classes.upload}>
                        {isLoading && <CircularProgress color="secondary" />}
                        <div className={classes.uploadInner} >
                            <UploadIcon style={props.itemRow.videoURL.hasError ? { color: 'red' } : {}} />
                            {/* <Box sx={{ display: {} }}> */}
                            <Typography variant="body2" style={props.itemRow.videoURL.hasError ? { color: 'red' } : {}}>
                                Drop here or click here to select.
                            </Typography>
                            {/* </Box> */}
                            <input
                                id={`url_${props.itemRow.id}`}
                                type="file"
                                className={classes.input}
                                onChange={handleOnChange}
                                title=" "
                                accept={allowedFileType}
                            />
                        </div>
                    </div>
                )}
            </Grid>

            <Grid size={{ xs: 8, md: 4 }} className={[classes.grid, { flexDirection: "row" }]}>
                <TextField
                    id={`title_${props.itemRow.id}`}
                    error={props.itemRow.title.hasError}
                    variant="outlined"
                    value={props.itemRow.title.value}
                    onChange={e => handleItemInputChange(e.target.value, 'title')}
                    title="Video Title"
                    size="small" style={{ width: '100%' }}
                />
            </Grid>

            <Grid size={{ xs: 4, md: 2 }} className={classes.gridIcons}>
                {props.itemRow?.reviewedReason && props.itemRow.videoCategory === AppConstants.VIDEO_TYPE.GAME_VIDEO &&
                    <IconButton
                        onClick={() => {
                            setPrimaryVideo(props.itemRow, props.itemRow?.isPrimaryVideo)
                        }}
                        title={props.itemRow?.isPrimaryVideo ? "Primary Video" : "Set as primary video"}
                        style={{
                            color: props.itemRow?.isPrimaryVideo ? '#daa520' : theme.palette.text.disabled,
                        }}>
                        <Star />
                    </IconButton>
                }
                <Tooltip title="Remove">
                    <IconButton onClick={(e) => {
                        setOpenConfirmationDialog(true)
                        setVideoToDelete(props.itemRow)
                    }}>
                        <DeleteIcon className={classes.btnDel} >Delete</DeleteIcon>
                    </IconButton>
                </Tooltip>
                {props.showAddOption &&
                    <Tooltip title="Add more">
                        <IconButton onClick={handleAddClick}>
                            <AddCircleIcon color="primary" >Add</AddCircleIcon>
                        </IconButton>
                    </Tooltip>
                }
            </Grid>
            {
                showError &&
                (<Grid size={{ xs: 12, md: 12 }} className={classes.grid}>
                    <Typography variant="caption" color="error">
                        {showError}
                    </Typography>
                </Grid>)
            }
            {
                props.itemRow.videoCategory === AppConstants.VIDEO_TYPE.GAME_VIDEO && props.itemRow?.reviewedReason && props.itemRow?.reviewedStatus !== AppConstants.REVIEW_STATUS.APPROVED &&
                <Grid size={{ xs: 12, md: 12 }} className={classes.grid}>
                    <Alert severity={AppConstants.StatusSeverityToColorMapper[props.itemRow.reviewedStatus]}>
                        {props.itemRow.reviewedStatus + " - " + props.itemRow.reviewedReason}
                    </Alert>
                </Grid>
            }

            <CofirmationDialogBox
                message={videoToDelete && videoToDelete.isPrimaryVideo
                    ? (
                        <div>
                            This is your primary profile video. Please select or upload another primary profile video.
                            <br /><br />
                            Are you sure you want to delete this entry?
                        </div>
                    )
                    : "Are you sure you want to delete this entry?"}
                open={openConfirmationDialog}
                onClose={() => handleConfirmation("N")}
                onYesClick={() => handleConfirmation("Y")}
                onNoClick={() => handleConfirmation("N")}
            ></CofirmationDialogBox>
        </Fragment >
    )
};

export default ProfileVideos;
